import type { GraphPerson } from "@/api/home-context"

export function cleanOnboardingMemoryFragment(
  input: string | null | undefined,
  max: number
): string {
  if (!input) return ""

  return (
    input
      // eslint-disable-next-line no-control-regex
      .replace(/[\u0000-\u001f\u007f]/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, max)
  )
}

export function selectOnboardingPeople(people: GraphPerson[], limit = 5): GraphPerson[] {
  return people
    .filter(
      (person) =>
        person.person_type?.class?.toLocaleLowerCase() === "person" &&
        Boolean(person.name?.trim()) &&
        Boolean(person.email?.trim())
    )
    .slice(0, limit)
}
